export const shape = {
    borderRadius: 8,
  };